// extracted by mini-css-extract-plugin
export default {"button":"styles_button__AClzr","button-normal":"styles_button-normal__H+cRl","button-outlined":"styles_button-outlined__7SuFF"};